import React from 'react';

import CategoryListing from '../category-listing';
import ProductListing from '../product-listing';

import type { BrandContentProps } from '..';
import * as S from '../styles';

const BrandContent = ({
  id,
  name,
  products,
  categories,
  categoryTree,
  analyticsAccessLink,
}: BrandContentProps) => (
  <div>
    <S.Header title={name}>
      {analyticsAccessLink && <S.Analytics>{analyticsAccessLink}</S.Analytics>}
    </S.Header>
    <ProductListing products={products} brandName={name} />
    <CategoryListing
      categories={categories}
      categoryTree={categoryTree}
      brand={{ id, name }}
    />
  </div>
);

export default BrandContent;
